import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import NuDate from "../../../../Components/Utils/NuDate";
import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { Progress } from "antd";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";

import { useFormik } from "formik";
import { handleKeyDown } from "../../../../Components/Utils/OtherFunction";
import { MainForm, MainFormInput } from "../../../../Components/Utils/MainForm";
import FilesView from "../../../../Components/Utils/FilesView";
import Modal from "../../../../Components/Utils/AttachmentView";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import { Tab, Tabs } from "../../../../Layouts/MainPage/Tabs";

import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import { CalendarDays, MapPin } from "lucide-react";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";

function ViewQuotes(onClose) {
  const { quotesViewId } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("form");
  const cdata = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  
  const [data,setData] = useState(cdata? cdata:null); 
  
 
  const[isSubmit,setisSubmited]=useState(false)
  

  function getView() {
    axiosInstance 
      .get(`/quotation/${quotesViewId}`)
      .then((res) => {
        setData(res.data?.data);    
        // setisSubmited(res.data?.data?.isSubmited === true);       

      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cdata) {
      getView();
    // }
  }, [])
  
  

    const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
    }
  }, [data]);

   const hasSidebarContent =
    GetAccess("client_details") ||
    GetAccess("comments")


    const [showLocationPopup, setShowLocationPopup] = useState(false);

     const id = quotesViewId; 
  const getUrl = `/quotation/get-status`;
  const putUrl = `/quotation/edit-status`; 
  const statusUrl = '/quotation/all-status';

  const [showPdfComponent, setShowPdfComponent] = useState(false);
  
  const handlePdfIconClick = () => {
    setShowPdfComponent(true);
  };
  const downloadPDF = async () => {
    try {
        const response = await axiosInstance.get(`/quotation/report/${quotesViewId}`, {
            responseType: 'blob' // Important to specify the response type as blob
        });
  
        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  
        // Create a link element
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `${data.ref}.pdf`; // The filename you want for the downloaded file
  
        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);
  
        // Programmatically click the link to trigger the download
        link.click();
  
        // Clean up and remove the link
        link.parentNode.removeChild(link);
  
    } catch (error) {
        console.error('Error downloading the PDF:', error);
    }
  };

  const [viewPDF,setViewPDF] = useState(null);
const [pdfLoading,setPdfLoading] = useState(false)

const ViewPDF = async () => {
  setPdfLoading(true)
  try {
      const response = await axiosInstance.get(`/quotation/report/${quotesViewId}`, {
          responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
      setPdfLoading(false)
  } catch (error) {
      console.error('Error downloading the PDF:', error);
      setPdfLoading(false)
  }
};

useEffect(() => {
  ViewPDF()
},[quotesViewId,data])

const [pdfAvailable, setPdfAvailable] = useState(false);

  const getpdf = () => {
    axiosInstance
      .get(`/quotation/report/${quotesViewId}`)
      .then((res) => {
        if (res.data?.data === true) {
          // setPdfAvailable(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getpdf();
  }, []);

  return (
 
    
 <div className=" px-4 py-2 w-full h-full">
       <div className="w-full mb-2 sm:flex justify-between items-start">
      <Breadcrumb
          items={[
            {
              name: "Quotation",
              link: "/quotation/quote",
            },
            { name: "View" },
          ]}
        />  
        <div className=" flex gap-2 justify-end">
                 <Link
                   to={`/quotation/quote`}
                   state={{
                     currentPage: pageIndex,
                     searchQuery: searchQuery != "" ? searchQuery : "",
                   }}
                 >
                   <BackButton link={true} />
                 </Link>
                 {GetAccess("quotes_edit")&&
                 <Link
                   to={`/quotation/quote/edit/${quotesViewId}`}
                   state={{
                     data: data,
                     from: `/quotation/quote/view/${quotesViewId}`,
                   }}
                 >
                   <EditButton height="8" />
                 </Link>}
                 
               </div>
      </div>
      <div className="w-full mx-auto h-[calc(100vh-160px)] mt-0.5  md:flex gap-x-2 text-[#111537]">
        <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center px-2 w-[80%]">
              
              <div className="sm:flex text-[14px] mb-2 text-[#111537] font-semibold ">
              <p className=" pr-0.5 ">{data?.refNumber} 
                {""} : {""}{data?.description || "None"}
                </p>   
                 {/* <p> : </p>
                <p className=" pl-0.5 ">
                  {data?.description || "None"}
                </p> */}
              </div>
              <div className="sm:flex gap-4 ">
                <p className="flex items-center gap-2 text-xs text-[#111537]">
                  <CalendarDays size={14} className="text-gray-500 shrink-0" />
                   {data?.date ? (
    <NuDate value={data?.date} format="DD-MMM-YYYY" /> 
  ) : (
    "N/A"
  )}</p>
         <p className="text-xs text-[#111537]"> Created By : {data?.createdByName || 'None'}</p>

              </div>
            </div>

           <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.status || "-"}
                            </div>
                          </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 ">
              {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.Date ? (
                      <NuDate
                        value={data?.Date}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div> */}
                   <div className="w-full flex px-2">
  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
    Total Price
  </p>
  <p className="w-[65%] py-2 text-xs font-medium text-[#606279] ">
    : <NuAmount  value={(data?.totalPrice)}/>
  </p>
</div>
                   <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Validity
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.validity}
                  </p>
                </div>
                {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Inspection Type
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.inspectionType}
                  </p>
                </div> */}
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Contract Number
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.contractNum}
                  </p>
                </div>
               
                {/* <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Start Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.startDate ? (
                      <NuDate
                        value={data?.startDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  End Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.endDate ? (
                      <NuDate
                        value={data?.endDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Renewal Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.renewalDate ? (
                      <NuDate
                        value={data?.renewalDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div> */}

                <div className="w-full flex px-2">
                            <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                           Delivery Terms
                            </p>
                            <p className="w-[65%] py-2 text-xs text-[#606279]">
                              : {data?.deliveryTerms}
                            </p>
                          </div>

                 <div className="w-full flex px-2">
                            <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                            Payment Terms
                            </p>
                            <p className="w-[65%] py-2 text-xs text-[#606279]">
                              : {data?.paymentTerms}
                            </p>
                          </div>

                           {/* <div className="w-full flex px-2">
                            <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                           Payment Method
                            </p>
                            <p className="w-[65%] py-2 text-xs text-[#606279]">
                              : {data?.paymentMethod}
                            </p>
                          </div> */}

               
                {/* <div className="w-full flex px-2">
  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
    Form Selection
  </p>
  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
    : {Array.isArray(data?.formNames) 
        ? data.formNames.join(", ") 
        : data?.formNames || "-"}
  </p>
</div> */}
             
              
              
              </div>
            </div>

            <div className="sm:flex gap-4 mt-4">
              <div className="sm:w-[50%] ">
        <p className="  text-xs font-medium text-[#111537] p-1">
              Special Notes
            </p>
        <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
           
            <p className="  text-xs p-2 break-words text-[#606279]">
              {data?.specialNotes || "-"}
            </p>
          </div>
          </div>

           <div className="sm:w-[50%] ">
        <p className="  text-xs font-medium text-[#111537] p-1">
              Comments
            </p>
        <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
           
            <p className="  text-xs p-2 break-words text-[#606279]">
              {data?.comments || "-"}
            </p>
          </div>
          </div>

          
            </div>

              <div className="sm:w-[50%] w-full ">
                <p className=" p-1 text-xs font-medium text-[#111537]">
                  Attachments
                </p>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                  
                  <div className="w-full flex gap-2 flex-wrap ">
                    {data?.attachments &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
              </div>
             {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div> */}

<div className="w-full bg-white border border-gray-200 my-4 rounded-lg">
  {/* Header for md+ screens */}
  <div className="hidden sm:flex w-full py-2 bg-baseColor-primary justify-between rounded-t-lg px-2">
    <p className="w-[5%] text-left text-white text-xs font-medium">S.No.</p>
    <p className="w-[50%] text-left text-white text-xs font-medium">Item</p>
    <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
    <p className="w-[15%] text-center text-white text-xs font-medium">Quantity</p>
    <p className="w-[15%] text-center text-white text-xs font-medium">Price</p>
  </div>

  {data?.items?.map((List, index) => (
    <div
      key={index}
      className="border-b sm:border-none w-full px-3 py-3 odd:bg-white even:bg-slate-100"
    >
      {/* Mobile layout */}
      <div className="block sm:hidden text-xs text-[#111537] space-y-1">
        <p><span className="font-semibold">S.No.:</span> {index + 1}</p>
        <p><span className="font-semibold">Item:</span> {List?.productName || "-"}</p>
        <p><span className="font-semibold">Unit:</span> {List?.unit || "-"}</p>
        <p><span className="font-semibold">Quantity:</span> {List?.quantity || "-"}</p>
        <p><span className="font-semibold">Price:</span> {List?.price || "-"}</p>
      </div>

      {/* Desktop layout */}
      <div className="hidden sm:flex w-full justify-between items-center text-xs text-[#111537]">
        <p className="w-[5%] text-left py-1">{index + 1}</p>
        <p className="w-[50%] text-left py-1">{List?.productName}</p>
        <p className="w-[10%] text-center py-1">{List?.unit}</p>
        <p className="w-[15%] text-center py-1">{List?.quantity}</p>
        <p className="w-[15%] text-center py-1">{List?.price}</p>
      </div>
    </div>
  ))}
</div>

    
      
          </div>
        </div>
                {(GetAccess("approvals") || GetAccess("client_details") || GetAccess("comments") ) && (
        
        <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
             {GetAccess("approvals")  &&(
<ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} refSetData={setData} data={data} type={"Survey"} preUrlName={"survey-report"}/>
 )}
            {GetAccess("client_details") &&(
            <div className="w-full grid  border border-gary   rounded-lg  mt-3">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Client Detail</p>
              </div>
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  Name
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  : {data?.clientName}
                </p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  {" "}
                  Reference
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  {" "}
                  : {data?.clientRefNumber}
                </p>
              </div>
            </div>
            )}
             <div className="w-full grid  border border-gary mt-3  rounded-lg ">
           <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">Report </p>
           <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
         

        <div onClick={handlePdfIconClick} className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border ">
          <svg
            width="20"
            height="20"
            className="fill-current text-baseColor-primary"

            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
          </svg>
          <p className=' w-auto  text-[9px]'>{data?.refNumber}</p>
        </div>
        </div>
        </div>

{/* <div className="w-full border border-gray-300 rounded-lg mt-4 shadow-sm overflow-hidden">
  <div className="bg-baseColor-primary p-2 rounded-t-lg flex justify-between">
    <p className="text-xs text-white font-semibold tracking-wide">Selected Forms</p>
    <div className="cursor-pointer" onClick={() => setShowLocationPopup(true)}>
  <MapPin size={15} color="#ffff" />
</div>

  </div>

  <div className="w-full px-3 py-2 overflow-y-auto h-52">
    {Array.isArray(data?.inspection) && data.inspection.length > 0 ? (
      (() => {
        // Collect all formSelectionName values
        const allFormNames = data.inspection
          .flatMap(item => item.formSelectionName || []);

        // Remove duplicates using Set
        const uniqueFormNames = [...new Set(allFormNames)];

        return uniqueFormNames.length > 0 ? (
          <div className="space-y-1">
            {uniqueFormNames.map((name, idx) => (
              <div
                key={idx}
                className="flex items-start gap-2 p-2 bg-white border border-gray-200 rounded-md text-xs text-gray-700 hover:bg-blue-50 transition"
              >
                <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                  {idx + 1}
                </div>
                <p className="flex-1">{name}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-500 py-2">No forms selected</p>
        );
      })()
    ) : (
      <p className="text-xs text-gray-500 py-2">No forms selected</p>
    )}
  </div>
</div> */}



           
          </div>
        </div>
        )}

      </div> 
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
            <PDFViewer pdfFile={selectedImage?.file} />
          ) : (
            <img src={selectedImage?.file} alt={selectedImage?.file} />
          )}
        </Modal>

    {/* </div> */}

    {showPdfComponent && (
  <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
  <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
    <button
              className="absolute top-2 right-2 text-white bg-red-600"
              onClick={() => setShowPdfComponent(false)}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <PDFViewer pdfFile={viewPDF}/>
      
     
     
    </div>
  </div>
)}
{showLocationPopup && (
  <div className="fixed top-0 left-0 w-full h-full bg-black/30 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in w-[98%] h-[98%] bg-white py-4 px-6 rounded-lg shadow-xl overflow-y-auto relative">

      {/* Close Button */}
      <button
        onClick={() => setShowLocationPopup(false)}
        className="absolute top-2 right-2 text-red-500 hover:text-red-700 text-lg"
      >
        ✕
      </button>

      <h2 className="text-sm font-semibold mb-4 text-[#111537]">Inspection Details</h2>

      {data?.inspection?.length > 0 ? (
        <div className="flex flex-wrap gap-4">
          {data.inspection.map((item, idx) => (
            <div key={idx} className="w-full sm:w-[48%] md:w-[32%] border border-gray-200 rounded-xl p-4 shadow-sm  hover:shadow-md transition">

              {/* Location & Type */}
              <div className="space-y-2 mb-3">
                <p className="text-sm text-[#111537] font-medium flex gap-2">
                <span className="mt-1"> <MapPin size={13} color="#b91c1c" /></span> <span className="font-semibold">Location:</span> {item.location}
                </p>
                <p className="text-sm text-[#111537] font-medium">
                  📝 <span className="font-semibold">Type:</span> {item.inspectionType}
                </p>
              </div>

              {/* Forms */}
              <div>
                <p className="text-sm text-[#111537] font-semibold mb-1">Form</p>
                <div className="flex flex-wrap gap-2">
                  {item.formSelectionName?.length > 0 ? (
                    item.formSelectionName.map((form, formIdx) => (
                      <span key={formIdx} className="px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                        {form}
                      </span>
                    ))
                  ) : (
                    <p className="text-xs text-gray-500">No forms selected</p>
                  )}
                </div>
              </div>

            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No inspection details available.</p>
      )}
    </div>
  </div>
)}
</div>
  );
}

export default ViewQuotes;
